import React from "react";
import { motion } from "framer-motion";
import { ShieldCheckIcon } from "lucide-react";
import { CTAButton } from "./CTAButton";
import { Countdown } from "./Countdown";
import { ScarcityBar } from "./ScarcityBar";
import { MOCKUP_MAIN } from "./data";
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-[var(--cream)] px-4 pb-10 pt-8 sm:pt-12" data-id="element-131" data-mp="4m8nyh6uizn1">
      <div className="mx-auto max-w-3xl text-center" data-id="element-132" data-mp="12a0mpfljy8wq">
        {/* Brand */}
        <motion.div initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="mb-6 inline-flex items-center gap-2" data-id="element-133" data-mp="xae9h65q4snx">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-[var(--brand)]" data-id="element-134" data-mp="s9ghy2ytqm9r">
            <ShieldCheckIcon className="h-5 w-5 text-white" data-id="element-135" data-mp="nbyj55eitnfh" />
          </span>
          <span className="font-serif-display text-lg font-bold tracking-tight text-[var(--brand)]" data-id="element-136" data-mp="3d2bidl8y6rtf">
            Clínica Segura<span className="align-super text-xs" data-id="element-137" data-mp="3814alm6t1smr">™</span>
          </span>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.05
      }} className="mx-auto mb-4 inline-flex items-center gap-1.5 rounded-full border border-[var(--brand)]/20 bg-white px-3 py-1 text-xs font-semibold text-[var(--brand)]" data-id="element-138" data-mp="3j9283w7ie4z8">
          🏥 PROTOCOLO CLÍNICA SEGURA™
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} className="font-serif-display text-[2rem] font-extrabold leading-[1.08] text-gray-900 sm:text-5xl" data-id="element-139" data-mp="30h9dxygpedpx">
          Diagnostica rehabilitaciones complejas en{" "}
          <span className="italic text-[var(--brand)]" data-id="element-140" data-mp="2vj7rr4nzdya8">menos de 15 minutos</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.2
      }} className="mx-auto mt-4 max-w-xl text-[15px] leading-relaxed text-gray-600 sm:text-lg" data-id="element-141" data-mp="2hjyn92950sm3">
          Un protocolo clínico paso a paso que reduce la incertidumbre y te ayuda a
          tomar decisiones con mayor seguridad. Incluye <strong data-id="element-142" data-mp="id9u8ert6duc">6 tomos</strong>,{" "}
          <strong data-id="element-143" data-mp="ia5jeyju8jup">5 herramientas profesionales</strong> y{" "}
          <strong data-id="element-144" data-mp="de6munocvvj7">más de 30 protocolos y checklists</strong>.
        </motion.p>

        {/* Mockup */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.94
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.25
      }} className="mx-auto mt-6 max-w-2xl" data-id="element-145" data-mp="1azuhp455y5sm">
          <img src={MOCKUP_MAIN} alt="Los 6 tomos y 5 bonos del Protocolo Clínica Segura" className="mx-auto w-full drop-shadow-2xl" data-id="element-146" data-mp="111ew1gownoqi" />
        </motion.div>

        {/* CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3
      }} className="mx-auto mt-2 max-w-lg" id="hero-cta" data-id="element-147" data-mp="3lquenodz0752">
          <CTAButton data-id="element-148" data-mp="21awco6qesnfd" />
          <p className="mt-3 text-xs font-medium text-gray-500 sm:text-sm" data-id="element-149" data-mp="21aejxk2ygrc7">
            Descarga inmediata · Pago único de <strong data-id="element-150" data-mp="269r7k71ni2fu">USD $12.99</strong> · Acceso de por vida · Garantía de 7 días
          </p>

          <div className="mt-6" data-id="element-151" data-mp="2b0zdgt3rv5o9">
            <Countdown data-id="element-152" data-mp="2b20qh34cm28m" />
          </div>

          <div className="mt-6" data-id="element-153" data-mp="2g02kgj3bblyv">
            <ScarcityBar data-id="element-154" data-mp="2fyr83uvsx5w5" />
          </div>
        </motion.div>
      </div>
    </header>;
}